export default __webpack_public_path__ + "static/media/dead.b3ac2523.jpg";